import type {NavigateFunction} from 'react-router-dom';

import {allRoutes} from '../../../constants/Routes';

export type PCFStepKey =
  | 'goalAndScope'
  | 'lciDataCollection'
  | 'impactConfiguration'
  | 'resultsInterpretation'
  | 'reportExport';

export const PCF_STEP_KEYS: PCFStepKey[] = [
  'goalAndScope',
  'lciDataCollection',
  'impactConfiguration',
  'resultsInterpretation',
  'reportExport'
];

export const getPCFStepPath = (
  step: PCFStepKey,
  id?: string | null
): string => (id ? `${allRoutes.PCF[step]}/${id}` : allRoutes.PCF[step]);

export const getPCFStepFromPathname = (
  pathname: string
): PCFStepKey | null => {
  for (const step of PCF_STEP_KEYS) {
    const base = allRoutes.PCF[step];
    if (pathname === base || pathname.startsWith(`${base}/`)) {
      return step;
    }
  }

  return null;
};

/** After first create save, replace id-less step URL with `/step/{recordId}`. */
export const syncPcfUrlWithRecordId = (
  navigate: NavigateFunction,
  pathname: string,
  routeId: string | null | undefined,
  newRecordId: string
): void => {
  if (routeId === newRecordId) {
    return;
  }

  const currentStep = getPCFStepFromPathname(pathname);
  if (!currentStep || routeId) {
    return;
  }

  navigate(getPCFStepPath(currentStep, newRecordId), {replace: true});
};
